import styled from "@emotion/styled";
import { StepPaperAProps } from "@src/ruix/types";

const StepPaperA = (props: StepPaperAProps) => {
	const borderColor = props.borderColor;

	const colors = {
		step1: "#BDD4FC",
		step2: "#7AA7F9",
		step3: "var(--primary)",
	};

	return (
		<StepPaperAComponent
			style={{
				borderTop: `4px solid ${colors[borderColor]}`,
			}}
		>
			{props.children}
		</StepPaperAComponent>
	);
};

const StepPaperAComponent = styled.div`
	display: flex;
	border-bottom-left-radius: 10px;
	border-bottom-right-radius: 10px;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
	padding: 20px 15px;
	background-color: white;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);

	@media screen and (min-width: 900px) {
		min-height: 500px;
	}
`;

export default StepPaperA;
